import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { NotificacaoCFCModel } from '@core/models/gestao/notificacao-cfc.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationCFCService extends BaseResourceService<NotificacaoCFCModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.MANAGEMENT_API}notificacaocfc`, injector);
  }

  getAll(params?: { [param: string]: any }): Observable<any> {
    if (params) {
      params.noLoad = true;
    }

    return this._httpClient.get<NotificacaoCFCModel[]>(`${this._url}`, { params });
  }
  saveRead(notification): Observable<NotificacaoCFCModel> {
    let params = {
      noInterceptor: 'true'
    };

    return this._httpClient.put<NotificacaoCFCModel>(`${this._url}`, notification, { params });
  }
}
